import { render, staticRenderFns } from "./InviteeDepositsDue.vue?vue&type=template&id=0ca60d80&scoped=true"
import script from "./InviteeDepositsDue.vue?vue&type=script&lang=js"
export * from "./InviteeDepositsDue.vue?vue&type=script&lang=js"
import style0 from "./InviteeDepositsDue.vue?vue&type=style&index=0&id=0ca60d80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca60d80",
  null
  
)

export default component.exports